/**
 * Local fallback for when the auth flow gets wedged (e.g., the user lands
 * on /callback without a valid `code`, or PKCE state is stale because of a
 * previous interrupted attempt). Clears anything Logto stashed in
 * localStorage so the next sign-in starts from a clean slate.
 *
 * `signOut()` is preferred when it's available, because it also revokes the
 * session on the Logto server. This helper is the offline/no-network fallback.
 */

export function clearLogtoStorage(): void {
  try {
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith('logto:')) keys.push(k);
    }
    for (const k of keys) localStorage.removeItem(k);
  } catch {
    // Storage may be disabled (incognito with strict settings, etc.).
    // Nothing actionable here — the user can clear site data manually.
  }
}
